import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { useTestId } from "@/hooks";
const PrimaryPriceComponentWrapper = ({ children, marginTop, }) => {
    const testId = useTestId("Sections.Price.PrimaryComponent");
    return (_jsx(Box, { borderRadius: "radius.16", borderColor: "color.border.light.default", borderStyle: "solid", borderWidth: "borderWidth.1", paddingTop: "spacing.24", paddingBottom: "spacing.8", testId: testId, marginTop: marginTop, children: children }));
};
const SecondaryPriceComponentWrapper = ({ children, marginTop, }) => {
    const testId = useTestId("Sections.Price.SecondaryComponent");
    return (_jsx(Box, { borderRadius: "radius.16", backgroundColor: "color.background.light", paddingVertical: "spacing.24", testId: testId, marginTop: marginTop, children: children }));
};
const TertiaryPriceComponentWrapper = ({ children, marginTop, }) => {
    const testId = useTestId("Sections.Price.TertiaryComponent");
    return (_jsx(Box, { borderRadius: "radius.16", marginLeft: "-spacing.16", testId: testId, marginTop: marginTop, children: children }));
};
export const ComponentWrapper = ({ type, children, marginTop, }) => {
    if (type === "TERTIARY") {
        return (_jsx(TertiaryPriceComponentWrapper, { marginTop: marginTop, children: children }));
    }
    if (type === "SECONDARY") {
        return (_jsx(SecondaryPriceComponentWrapper, { marginTop: marginTop, children: children }));
    }
    return (_jsx(PrimaryPriceComponentWrapper, { marginTop: marginTop, children: children }));
};
